import { accountProfilePictureUrl, orgLogoUrl } from '@api/urls';

export function useProfilePictureLink(accountId, preventLiveUpdate) {
  return `${accountProfilePictureUrl}?id=${accountId}&timestamp=${preventLiveUpdate ? 0 : Date.now()}`;
}

export function useOrgLogoLink(orgId) {
  return `${orgLogoUrl}?id=${orgId}&timestamp=${Date.now()}`;
}
